const PERMISSION_KEY= "core:membership_subscription_user";
const PAGE_URL = {
    MEMBERSHIP_SUBSCRIPTION_USER_PAGE: "/admin/core/membership-subscription-user"
}

export {PERMISSION_KEY, PAGE_URL}

